export type { ProductImageUploadTranslations } from "./product-image-upload-pt-br";
export { PRODUCT_IMAGE_UPLOAD_PT_BR } from "./product-image-upload-pt-br";
export { PRODUCT_IMAGE_UPLOAD_EN_US } from "./product-image-upload-en-us";
export { PRODUCT_IMAGE_UPLOAD_ES_ES } from "./product-image-upload-es-es";
export { PRODUCT_IMAGE_UPLOAD_ES_MX } from "./product-image-upload-es-mx";
export { PRODUCT_IMAGE_UPLOAD_FR_FR } from "./product-image-upload-fr-fr";
